import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toastTheme.css";
import { useDispatch } from "react-redux";
import { getUserDetails, login, logout } from "./reducers/auth";
import AdminRoutes from "./routes/AdminRoutes";
import ScRoutes from "./routes/ScRoutes";
import PartnerRoutes from "./routes/PartnerRoutes";
import AppLoader from "./component/AppLoader";

function App() {
  const isLoggedIn = useSelector((state) => state.authReducer.isLoggedIn);
  const user = useSelector((state) => state.authReducer.currentUser);
  const dispatch = useDispatch();
  const [isAppReady, setAppReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    try {
      if (token) {
        dispatch(login({ token }));
        dispatch(getUserDetails());
      } else {
        dispatch(logout());
      }
    } catch (error) {
      dispatch(logout());
    } finally {
      setAppReady(true);
    }
  }, [dispatch]);

  if (!isAppReady || (isLoggedIn && !user)) return <AppLoader />;

  const roleId = user?.role_id;
  const entityType = user?.entity_type;

  return (
    <div className="wrapper">
      <BrowserRouter>
        {!isLoggedIn && (
          <>
            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route exact path="/login" element={<Login />} />
              <Route exact path="*" element={<Navigate to="/login" />} />
            </Routes>
          </>
        )}
        {/* {console.log(Number(entityType))} */}
        {isLoggedIn && Number(entityType) === 1 && <AdminRoutes isLoggedIn={isLoggedIn} roleId={roleId}/>}
        {isLoggedIn && Number(entityType) === 3 && <ScRoutes isLoggedIn={isLoggedIn}/>}
        {isLoggedIn && Number(entityType) === 2 && <PartnerRoutes isLoggedIn={isLoggedIn}/>}
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        className="app-toast-container"
      />
    </div>
  );
}

export default App;
